import React, { useMemo } from 'react';
import moment from 'moment';
import type Trip from '@this/domain/trip/trip2';

type TripUserInfo = {
  name: string;
  name_roman: string;
  birthday: string;
  age: number | null;
  gender: string;
  tel: string;
  email: string;
  domestic_approval_required: boolean;
  foreign_approval_required: boolean;
  department: { name: string };
};

interface Props {
  trip: Trip;
}

const sectionTitleStyle: React.CSSProperties = {
  marginBottom: '4px'
};

export const TravelRegulationUserInfo: React.FC<Props> = ({ trip }) => {
  const travelerInfo = useMemo(() => {
    if (!trip.currentOrder || !trip.currentOrder.orderItems) return null;
    if (trip.currentOrder.orderItems[0] === undefined) return null;
    if (trip.currentOrder.orderItems[0].travelerInformations === undefined) return null;
    if (trip.currentOrder.orderItems[0].travelerInformations[0] === undefined) return null;
    return trip.currentOrder.orderItems[0].travelerInformations[0].user;
  }, [trip]);

  const userInfo = useMemo<TripUserInfo>(() => {
    const birthday = trip.user.birthday;

    return {
      name: trip.user.name,
      name_roman: `${trip.user.lastNameRoman} ${trip.user.firstNameRoman}`,
      birthday: birthday ? birthday.format('YYYY-MM-DD') : '',
      age: moment().diff(moment(birthday, 'YYYY-MM-DD'), 'years'),
      gender: trip.user.gender ?? '',
      tel: trip.user.nationalizedTel ?? '',
      email: trip.user.email ?? '',
      domestic_approval_required: trip.user.domesticApprovalRequired ?? false,
      foreign_approval_required: trip.user.foreignApprovalRequired ?? false,
      department: {
        name: utils.dig(trip, 'user', 'department', 'name') ?? ''
      }
    };
  }, [trip]);

  return (
    <>
      <h3 style={sectionTitleStyle}>旅費規程適用ユーザ(出張代表者)情報</h3>

      {travelerInfo ? (
        <ul>
          <li>氏名: {travelerInfo.name}</li>
          <li>ローマ字: {`${travelerInfo.lastNameRoman} ${travelerInfo.firstNameRoman}`}</li>
          <li>
            生年月日:{' '}
            {travelerInfo.birthday
              ? `${moment(travelerInfo.birthday).format('YYYY-MM-DD')}(${moment().diff(
                  moment(travelerInfo.birthday),
                  'years'
                )}歳)`
              : ''}
          </li>
          <li>性別: {travelerInfo.gender}</li>
          <li>Tel: {travelerInfo.nationalizedTel}</li>
          <li>E-mail: {travelerInfo.email}</li>
          <li>役職等級: {utils.dig(travelerInfo, 'grade', 'name') || ''}</li>
          <li>部署: {utils.dig(travelerInfo, 'department', 'name') || ''}</li>
          <li>国内承認: {travelerInfo.domesticApprovalRequired ? 'あり' : 'なし'}</li>
          <li>海外承認: {travelerInfo.foreignApprovalRequired ? 'あり' : 'なし'}</li>
        </ul>
      ) : (
        <ul>
          <li>氏名: {userInfo.name}</li>
          <li>ローマ字: {userInfo.name_roman}</li>
          <li>生年月日: {`${userInfo.birthday}(${userInfo.age}歳)`}</li>
          <li>性別: {userInfo.gender}</li>
          <li>Tel: {userInfo.tel}</li>
          <li>E-mail: {userInfo.email}</li>
          <li>部署: {userInfo.department.name}</li>
          <li>国内承認: {userInfo.domestic_approval_required ? 'あり' : 'なし'}</li>
          <li>海外承認: {userInfo.foreign_approval_required ? 'あり' : 'なし'}</li>
        </ul>
      )}
    </>
  );
};
